module.exports = {
      id: "tick_inside_the_square-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#tick_inside_the_square-usage",
      toString: function () {
        return this.url;
      }
    }